import { has } from "shared/utils";
import { Cell } from "./Cell";
import { ReportStatusBadge } from "./ReportStatusBadge";
import { Verification } from "../types";

interface RentalApplicationCellProps {
  verification: Verification;
}

export const RentalApplicationCell = ({
  verification
}: RentalApplicationCellProps) => {
  return (
    <>
      <Cell isDataCell className="relative">
        {has(verification.summary?.total_dependents)
          ? verification.summary.total_dependents
          : "-"}
        <ReportStatusBadge verificationStatus={verification.status} />
      </Cell>
      <Cell isDataCell>
        {has(verification.summary?.total_vehicles)
          ? verification.summary.total_vehicles
          : "-"}
      </Cell>
      <Cell isDataCell>
        {has(verification.summary?.total_pets)
          ? verification.summary.total_pets
          : "-"}
      </Cell>
    </>
  );
};
